module.exports = __webpack_public_path__ + "static/media/tally.ef831661.svg";